import { Component } from '@angular/core';

@Component({
  selector: 'signgaze-listing-comments',
  templateUrl: './listing-comments.component.html',
  styleUrls: ['./listing-comments.component.scss'],
})
export class ListingCommentsComponent {}
